import { render } from "./IframeModal.vue?vue&type=template&id=17d64ff8&scoped=true"
import script from "./IframeModal.vue?vue&type=script&lang=js"
export * from "./IframeModal.vue?vue&type=script&lang=js"

import "./IframeModal.vue?vue&type=style&index=0&id=17d64ff8&scoped=true&lang=css"

import exportComponent from "D:\\TeamCity\\BuildAgent2\\work\\1bfd74eb4d5fb108\\FamilyPortalApp\\familyportal-app\\src\\familyportal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d64ff8"]])

export default __exports__